"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
class EventEmitter {
    constructor() {
        this.events = new Map();
    }
    add(type, callback) {
        const callbacks = this.events.get(type) || [];
        callbacks.push(callback);
        this.events.set(type, callbacks);
        return this;
    }
    remove(type, callback) {
        const callbacks = this.events.get(type) || [];
        this.events.set(type, callbacks.filter((fn) => fn !== callback));
        return this;
    }
    removeByType(type) {
        this.events.delete(type);
        return this;
    }
    emit(type, ...args) {
        const callbacks = this.events.get(type) || [];
        callbacks.forEach((fn) => {
            fn(...args);
        });
        return this;
    }
    listeners(type) {
        return Object.freeze(this.events.get(type) || []);
    }
}
exports.EventEmitter = EventEmitter;
